import { render, staticRenderFns } from "./whatIsItForCard.vue?vue&type=template&id=38e8209e&scoped=true"
import script from "./whatIsItForCard.vue?vue&type=script&lang=js"
export * from "./whatIsItForCard.vue?vue&type=script&lang=js"
import style0 from "./whatIsItForCard.vue?vue&type=style&index=0&id=38e8209e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8209e",
  null
  
)

export default component.exports